"use client";
import { jsx as s } from "react/jsx-runtime";
import * as i from "@radix-ui/react-tabs";
import { cn as a } from "./index.es21.js";
const r = ({ className: e, ...t }) => /* @__PURE__ */ s(i.Root, { "data-slot": "tabs", className: a("flex flex-col gap-2", e), ...t }), l = ({ className: e, ...t }) => /* @__PURE__ */ s(
  i.List,
  {
    "data-slot": "tabs-list",
    className: a("inline-flex h-13 w-fit items-center justify-center", e),
    ...t
  }
), c = ({ className: e, ...t }) => /* @__PURE__ */ s(
  i.Trigger,
  {
    "data-slot": "tabs-trigger",
    className: a(
      `data-[state=active]:bg-gray-800 data-[state=active]:text-white data-[state=active]:rounded-capsule 
                inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-3 rounded-md border border-transparent px-4 py-3 text-base border-none whitespace-nowrap
                focus-visible:border-ring focus-visible:ring-ring/50
                focus-visible:outline-2 focus-visible:outline-blue-600 focus-visible:outline-offset-2
                disabled:pointer-events-none disabled:opacity-50 hover:cursor-pointer
                [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4`,
      e
    ),
    ...t
  }
), b = ({ className: e, ...t }) => /* @__PURE__ */ s(i.Content, { "data-slot": "tabs-content", className: a("flex-1 outline-none", e), ...t });
export {
  b as TabsContent,
  l as TabsList,
  r as TabsRoot,
  c as TabsTrigger
};
